import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SubHeader from '../../layout/components/SubHeader';
import { useEyeconxStore } from '../../../store/eyeconxStore';
import surveyService from '../../../services/survey.service';
import './Surveys.css';

function SurveyResultPage() {
    const { surveyId } = useParams();
    const clinicId = useEyeconxStore((state) => state.user?.clinicId);
    const [survey, setSurvey] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!clinicId || !surveyId) return;
        setLoading(true);
        surveyService
            .getClinicSurveyById(clinicId, surveyId)
            .then((res) => setSurvey(res.data.survey || null))
            .catch(() => setSurvey(null))
            .finally(() => setLoading(false));
    }, [clinicId, surveyId]);

    return (
        <div className="ecx-page surveys-page ecx-page--full-width">
            <SubHeader
                title={survey?.title || 'Survey results'}
                description="Response analytics for this clinic survey"
                icon="bi-clipboard-check"
                containerClass="w-100 px-4"
            >
                <div className="d-flex gap-2">
                    <Link to={`/surveys/${surveyId}/edit`} className="btn btn-sm btn-outline-secondary rounded-pill">
                        <i className="bi bi-pencil me-1" />
                        Edit survey
                    </Link>
                    <Link to="/surveys" className="btn btn-sm btn-outline-secondary rounded-pill">
                        <i className="bi bi-chevron-left me-1" />
                        Back
                    </Link>
                </div>
            </SubHeader>

            <div className="ecx-page-body">
                <div className="ecx-page-card ecx-page-panel">
                    <div className="ecx-page-panel__body py-5 text-center">
                        {loading ? (
                            <div className="text-muted">Loading survey…</div>
                        ) : (
                            <>
                                <div className="mb-3">
                                    <i className="bi bi-bar-chart-line fs-1 text-muted" />
                                </div>
                                <h2 className="h5 mb-2">Results coming soon</h2>
                                <p className="text-muted mb-0 mx-auto" style={{ maxWidth: '28rem' }}>
                                    Survey response collection is not available in EyeconX-API yet.
                                    Target / max response settings
                                    {survey?.targetResponse != null || survey?.maxResponse != null
                                        ? ` (target ${survey?.targetResponse ?? '—'}, max ${survey?.maxResponse ?? '—'})`
                                        : ''}{' '}
                                    are saved on the survey, but patient submissions are not stored in this
                                    version.
                                </p>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SurveyResultPage;
